export default __webpack_public_path__ + "static/media/AndrzejSwatowski.660cf0c3.png";